import { render, staticRenderFns } from "./Customer-delivery-calendar.vue?vue&type=template&id=1575bc86&scoped=true&"
import script from "./Customer-delivery-calendar.vue?vue&type=script&lang=js&"
export * from "./Customer-delivery-calendar.vue?vue&type=script&lang=js&"
import style0 from "./Customer-delivery-calendar.vue?vue&type=style&index=0&id=1575bc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575bc86",
  null
  
)

export default component.exports